(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $25396bf52af4f129$exports = {};
"use strict";
var $b73e9dd2f1c791ca$exports = {};
$b73e9dd2f1c791ca$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $25396bf52af4f129$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $25396bf52af4f129$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $25396bf52af4f129$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $25396bf52af4f129$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $b73e9dd2f1c791ca$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $25396bf52af4f129$var$clipboardToIE11Formatting[options.format] || $25396bf52af4f129$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $25396bf52af4f129$var$format("message" in options ? options.message : $25396bf52af4f129$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$25396bf52af4f129$exports = $25396bf52af4f129$var$copy;


function $6d303afa5b6f453f$export$2cdf1b96a9f86d16(text) {
    (0, (/*@__PURE__*/$parcel$interopDefault($25396bf52af4f129$exports)))(text);
} /*
export async function copyToClipboard(text: string) {
  await navigator.clipboard.writeText(text)
}
*/ 


//
// After a successful login we are redirected to the UI with our username
// and a JWT token. We need to save these in local storage so Verdaccio
// thinks we are logged in.
//
/**
 * Returns cookies as an object
 */ function $0c878e4f973eff4a$export$d2e637738f5e6ae8(cookieStr) {
    return cookieStr.split(";").filter((str)=>str.includes("=")).map((str)=>str.split("=")).reduce((result, [key, value])=>({
            ...result,
            [decodeURIComponent(key.trim())]: decodeURIComponent(value.trim())
        }), {});
}
function $0c878e4f973eff4a$export$83cd1f1503eb19c0(token) {
    // JWT has 3 parts separated by ".", the payload is the base64url-encoded part in the middle
    const base64Url = token.split(".")[1];
    // base64url replaced '+' and '/' with '-' and '_', so we undo it here
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64).split("")// atob decoded the base64 string, but multi-byte characters (emojis for example)
    // are not decoded properly. For example, "🍀" looks like "ð\x9F\x8D\x80". The next
    // line converts bytes into URI-percent-encoded format, for example "%20" for space.
    // Lastly, the decodeURIComponent wrapping this can correctly get a UTF-8 string.
    .map((c)=>"%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)).join(""));
    return JSON.parse(jsonPayload);
}
function $0c878e4f973eff4a$export$9369b12211e1fce4(action) {
    for(let i = 0; i < 10; i++)setTimeout(()=>action(), 100 * i);
}
function $0c878e4f973eff4a$var$pathContainsElement(selector, e) {
    const path = e.path || e.composedPath?.();
    const element = document.querySelector(selector);
    return path.includes(element);
}
function $0c878e4f973eff4a$export$60561518b076cb2c(selector, callback) {
    const handleClick = (e)=>{
        if ($0c878e4f973eff4a$var$pathContainsElement(selector, e)) {
            e.preventDefault();
            e.stopPropagation();
            callback();
        }
    };
    const capture = true;
    document.addEventListener("click", handleClick, capture);
}


function $95eebdd339d9815e$export$787d85d17a1ab0c9(credentials) {
    localStorage.setItem("username", credentials.username);
    localStorage.setItem("token", credentials.uiToken);
    localStorage.setItem("npm", credentials.npmToken);
}
function $95eebdd339d9815e$export$d1b63878dfcc70a6() {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("npm");
}
function $95eebdd339d9815e$export$256a5a3564694cfc() {
    return !!localStorage.getItem("username") && !!localStorage.getItem("token") && !!localStorage.getItem("npm");
}
function $95eebdd339d9815e$export$b007d77a962aa175() {
    const token = localStorage.getItem("token");
    if (typeof token !== "string") return true;
    const payload = (0, $0c878e4f973eff4a$export$83cd1f1503eb19c0)(token);
    if (!payload) return true;
    // Report as expired before (real expiry - 30s)
    const jsTimestamp = payload.exp * 1000 - 30000;
    return Date.now() >= jsTimestamp;
}
function $95eebdd339d9815e$export$65f22a49577e07ee(credentials) {
    return credentials.username && credentials.uiToken && credentials.npmToken;
}


var $3866530661496f9f$exports = {};
$3866530661496f9f$exports = JSON.parse("{\"$schema\":\"http://json.schemastore.org/package\",\"name\":\"verdaccio-passport-google-oauth-ui\",\"version\":\"0.1.9\",\"keywords\":[\"authentication\",\"google\",\"login\",\"npm\",\"oauth\",\"package\",\"passport\",\"private\",\"registry\",\"verdaccio\",\"verdaccio-auth\",\"verdaccio-auth-plugin\",\"verdaccio-plugin\"],\"bugs\":\"https://github.com/okayasu/verdaccio-passport-google-oauth-ui/issues\",\"repository\":\"github:okayasu/verdaccio-passport-google-oauth-ui\",\"license\":\"MIT\",\"author\":\"Masanori Okayasu\",\"main\":\"dist/server/index.js\",\"bin\":\"dist/cli/index.js\",\"files\":[\"dist\",\"verdaccio.yaml\"],\"scripts\":{\"build\":\"bash run build\",\"clean\":\"bash run clean\",\"cli\":\"bash run cli\",\"cli:login\":\"bash run cli-login\",\"cli:publish\":\"bash run cli-publish\",\"cli:whoami\":\"bash run cli-whoami\",\"copy\":\"bash run copy\",\"coverage\":\"vitest --coverage\",\"dev\":\"yarn update && yarn start\",\"docker\":\"bash run docker_\",\"fix\":\"yarn format && yarn typecheck\",\"format\":\"prettier --write \\\"**/*.{ts,js,css,scss,html,json}\\\"\",\"format:check\":\"prettier --check \\\"**/*.{ts,js,css,scss,html,json}\\\"\",\"prepack\":\"bash run clean && bash run build\",\"start\":\"verdaccio -c verdaccio.yaml\",\"test\":\"vitest\",\"typecheck\":\"bash run typecheck\",\"update\":\"yarn prepack && yarn copy\",\"watch\":\"nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \\\"yarn dev\\\"\"},\"dependencies\":{\"@verdaccio/url\":\"^11.0.0-6-next.42\",\"copy-to-clipboard\":\"^3.3.3\",\"dotenv\":\"^17.2.2\",\"express\":\"^5.1.0\",\"global-agent\":\"^3.0.0\",\"lodash\":\"^4.17.21\",\"minimist\":\"^1.2.8\",\"open\":\"^10.2.0\",\"ow\":\"^2.0.0\",\"passport\":\"^0.7.0\",\"passport-google-oauth\":\"^2.0.0\",\"picocolors\":\"^1.1.1\"},\"devDependencies\":{\"@parcel/config-default\":\"^2.15.4\",\"@parcel/transformer-typescript-tsc\":\"^2.15.4\",\"@types/express\":\"^5.0.3\",\"@types/global-agent\":\"^3.0.0\",\"@types/lodash\":\"^4.17.20\",\"@types/minimist\":\"^1.2.5\",\"@types/node\":\"^24.3.0\",\"@types/passport\":\"^1.0.17\",\"@types/passport-google-oauth\":\"^1.0.45\",\"@verdaccio/types\":\"^10.8.0\",\"@vitest/coverage-v8\":\"^3.2.4\",\"browserslist\":\"^4.27.0\",\"core-js\":\"^3.46.0\",\"nodemon\":\"^3.1.10\",\"parcel\":\"^2.15.4\",\"prettier\":\"^3.6.2\",\"process\":\"^0.11.10\",\"timekeeper\":\"^2.3.1\",\"type-fest\":\"^4.41.0\",\"typescript\":\"^5.9.3\",\"verdaccio\":\"~6.1.6\",\"verdaccio-htpasswd\":\"^10.5.5\",\"vitest\":\"^3.2.4\"},\"peerDependencies\":{\"verdaccio\":\">=5\"},\"packageManager\":\"yarn@4.8.1\",\"publishConfig\":{\"registry\":\"https://registry.npmjs.org/\"},\"targets\":{\"client\":{\"source\":\"src/client/verdaccio-5.ts\",\"distDir\":\"dist/client\",\"context\":\"browser\",\"includeNodeModules\":true},\"server\":{\"source\":\"src/server/index.ts\",\"distDir\":\"dist/server\",\"context\":\"node\",\"outputFormat\":\"commonjs\",\"optimize\":false,\"isLibrary\":true},\"cli\":{\"source\":\"src/cli/index.ts\",\"distDir\":\"dist/cli\",\"context\":\"node\",\"outputFormat\":\"commonjs\",\"optimize\":false}}}");


const $56594a4f7cb38e49$export$3a689f099db7e338 = (0, (/*@__PURE__*/$parcel$interopDefault($3866530661496f9f$exports))).name;
const $56594a4f7cb38e49$export$18d4026d1ea86bb1 = (0, (/*@__PURE__*/$parcel$interopDefault($3866530661496f9f$exports))).name.replace("verdaccio-", "");
const $56594a4f7cb38e49$export$42fcb85fa5803dac = "/-/oauth/authorize";
const $56594a4f7cb38e49$export$9e960429933a7149 = "/-/oauth/callback";
const $56594a4f7cb38e49$export$cf98473208e53590 = $56594a4f7cb38e49$export$42fcb85fa5803dac;
const $56594a4f7cb38e49$export$bd46c9d2d39fc9 = "/";
const $56594a4f7cb38e49$export$3c6c1020e175037c = 8239;
const $56594a4f7cb38e49$export$32fbdff0ec95e1c6 = "cli";
const $56594a4f7cb38e49$export$b3d17af05dbcae2f = "/oauth/authorize";
const $56594a4f7cb38e49$export$827c2d0b213c39b9 = [
    "$all",
    "@all",
    "$authenticated",
    "@authenticated"
];




function $d5b78e1f3fe47884$var$saveAndRemoveCookies() {
    if ((0, $95eebdd339d9815e$export$b007d77a962aa175)()) (0, $95eebdd339d9815e$export$d1b63878dfcc70a6)();
    const credentials = (0, $0c878e4f973eff4a$export$d2e637738f5e6ae8)(document.cookie);
    if (!(0, $95eebdd339d9815e$export$65f22a49577e07ee)(credentials)) return;
    (0, $95eebdd339d9815e$export$787d85d17a1ab0c9)(credentials);
    Object.keys(credentials).forEach((key)=>document.cookie = `${key}=;expires=${new Date(0).toUTCString()}`);
    location.reload();
}
function $d5b78e1f3fe47884$export$2cd8252107eb640b(options) {
    $d5b78e1f3fe47884$var$saveAndRemoveCookies();
    const { loginButton: loginButton, logoutButton: logoutButton, updateUsageInfo: updateUsageInfo } = options;
    (0, $0c878e4f973eff4a$export$60561518b076cb2c)(loginButton, ()=>{
        if (location.pathname === (0, $56594a4f7cb38e49$export$cf98473208e53590)) location.reload();
        else location.href = (0, $56594a4f7cb38e49$export$cf98473208e53590);
    });
    (0, $0c878e4f973eff4a$export$60561518b076cb2c)(logoutButton, ()=>{
        (0, $95eebdd339d9815e$export$d1b63878dfcc70a6)();
        location.href = (0, $56594a4f7cb38e49$export$bd46c9d2d39fc9);
    });
    document.addEventListener("click", ()=>(0, $0c878e4f973eff4a$export$9369b12211e1fce4)(updateUsageInfo));
    (0, $0c878e4f973eff4a$export$9369b12211e1fce4)(updateUsageInfo);
}


//
// Replace the default npm usage info and displays the authToken that needs
// to be configured.
//
function $5a55543d6bc7f750$export$9dc0174526f4c7e3() {
    const username = localStorage.getItem("username");
    if (!username) return "Click the login button to authenticate with Google.";
    const configBase = window.VERDACCIO_API_URL ? window.VERDACCIO_API_URL.replace(/^https?:/, "").replace(/-\/verdaccio\/$/, "") : `//${location.host}${location.pathname}`;
    const authToken = localStorage.getItem("npm");
    return [
        `npm config set ${configBase}:_authToken "${authToken}"`
    ].join("\n");
}




const $45e6ef2ace6bee4a$var$loginButtonSelector = `[data-testid="header--button-login"]`;
const $45e6ef2ace6bee4a$var$logoutButtonSelector = `[data-testid="header--button-logout"],[data-testid="logOutDialogIcon"]`;
const $45e6ef2ace6bee4a$var$tabSelector = `[data-testid="tab-content"]`;
function $45e6ef2ace6bee4a$var$updateUsageInfo() {
    const loggedIn = (0, $95eebdd339d9815e$export$256a5a3564694cfc)();
    if (!loggedIn) return;
    const tabs = document.querySelectorAll($45e6ef2ace6bee4a$var$tabSelector);
    if (!tabs) return;
    const usageInfoLines = (0, $5a55543d6bc7f750$export$9dc0174526f4c7e3)().split("\n").reverse();
    tabs.forEach((tab)=>{
        const alreadyReplaced = tab.getAttribute("replaced") === "true";
        if (alreadyReplaced) return;
        const commands = Array.from(tab.querySelectorAll("button")).map((node)=>node.parentElement).filter((node)=>!!node.innerText.match(/^(npm|pnpm|yarn)/));
        if (!commands.length) return;
        usageInfoLines.forEach((info)=>{
            const cloned = commands[0].cloneNode(true);
            const textEl = cloned.querySelector("span");
            textEl.innerText = info;
            const copyEl = cloned.querySelector("button");
            copyEl.style.visibility = loggedIn ? "visible" : "hidden";
            copyEl.onclick = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                (0, $6d303afa5b6f453f$export$2cdf1b96a9f86d16)(info);
            };
            commands[0].parentElement.appendChild(cloned);
            tab.setAttribute("replaced", "true");
        });
        // Remove commands that don't work with oauth
        commands.forEach((node)=>{
            if (node.innerText.includes("adduser") || node.innerText.includes("set password")) {
                node.parentElement.removeChild(node);
                tab.setAttribute("replaced", "true");
            }
        });
    });
}
(0, $d5b78e1f3fe47884$export$2cd8252107eb640b)({
    loginButton: $45e6ef2ace6bee4a$var$loginButtonSelector,
    logoutButton: $45e6ef2ace6bee4a$var$logoutButtonSelector,
    updateUsageInfo: $45e6ef2ace6bee4a$var$updateUsageInfo
});

})();
//# sourceMappingURL=verdaccio-5.js.map
